import { useContext } from "react";
import { PermissionContext } from "../context/PermissionContext";

const usePermissionContext = () => useContext(PermissionContext);
export default usePermissionContext;
